import { BordButton } from 'bord-design-system';
import './QuoteEditorActions.scss';

interface IQuoteEditorActions {
  canMarkAsQuoted: boolean;
  canSendQuote: boolean;
  isSubmitting: boolean;
  onMarkAsQuoted: () => void;
  onSendQuote: () => void;
}

/**
 * Barra fija de acciones en la parte inferior del editor de cotización.
 * Contiene los botones para marcar una herramienta como cotizada y enviar la cotización completa.
 */
const QuoteEditorActions = ({
  canMarkAsQuoted,
  canSendQuote,
  isSubmitting,
  onMarkAsQuoted,
  onSendQuote
}: IQuoteEditorActions) => {
  return (
    <div className="quoteEditorActions">
      <BordButton
        label="Marcar herramienta como cotizada"
        bordButtonStyle="outlined"
        disabled={!canMarkAsQuoted}
        isLoading={isSubmitting}
        onClick={onMarkAsQuoted}
        customClassName="markAsQuotedBtn"
        style={{ width: '28rem' }}
      />
      <BordButton
        label="Enviar cotización"
        buttonIconOne="send"
        disabled={!canSendQuote}
        onClick={onSendQuote}
        customClassName="sendQuoteBtn"
        style={{ width: '28rem' }}
      />
    </div>
  );
};

export default QuoteEditorActions;
